import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import React, { useCallback } from 'react';
import { useRecoilState } from 'recoil';
import BeaconFilterItem from '../../../models/BeaconFilterItem';
import stateFilterSex from '../../../state/stateFilterSex';

const SEX_VALUES: BeaconFilterItem[] = [
  { type: 'ontology', id: 'Gender:F', label: 'Female' },
  { type: 'ontology', id: 'Gender:M', label: 'Male' },
];

function QuerySex() {
  const [filterSex, setFilterSex] = useRecoilState(stateFilterSex);

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>, value: string) => {
      if (value !== (filterSex || {}).id) {
        const item = SEX_VALUES.find((elem) => elem.id === value) || null;
        setFilterSex(item);
      }
    },
    [filterSex, setFilterSex]
  );
  const value = (filterSex || {}).id || '-';
  return (
    <RadioGroup
      row
      aria-labelledby="demo-radio-buttons-group-label"
      name="radio-buttons-group"
      onChange={handleChange}
    >
      <FormControlLabel
        value=""
        control={<Radio />}
        label="Any"
        checked={'-' === value}
      />
      {SEX_VALUES.map((elem) => (
        <FormControlLabel
          key={elem.id}
          value={elem.id}
          control={<Radio />}
          label={elem.label}
          checked={elem.id === value}
        />
      ))}
    </RadioGroup>
  );
}

export default QuerySex;
